import { Suspense, useEffect } from 'react';

import { Switch, Route } from 'react-router-dom';

import { AddCompanyShareholdersForm } from './addCompanyShareholders/AddCompanyShareholdersForm';
import { ConfirmDeliveryAddress } from './confirmDeliveryAddress/ConfirmDeliveryAddress';
import { DocumentSigningView } from './documents/DocumentSigningView';
import { CompleteIDCheckForm } from './idCheck/CompleteIDCheckForm';
import { OnboardingLayout } from './layout/OnboardingLayout';
import { Onboarding } from './Onboarding';
import { OnboardingChecks } from './onboardingChecks/OnboardingChecks';
import { ErrorBoundary } from '../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../modals/fallbackErrorModal/FallbackErrorModal';
import { useNavVisibility } from '../../navigation/useNavVisibility';
import MainContentPending from '../../pageStructure/mainContentPending';
import { ONBOARDING_PATHS, ONBOARDING_BASE_URL } from '../constants';
import { AddPaymentMethodForm } from './addPaymentMethod/AddPaymentMethodForm';
import IwStripeProvider from '../../../iwStripeProvider/IwStripeProvider';
import { getStripePublicKey } from '../../../iwStripeProvider/StripeHelper';

export const OnboardingRoutes = () => {
    const { setShowNav } = useNavVisibility();

    useEffect(() => {
        // Hide nav when this route is active
        setShowNav(false);

        // On unmount, put it back
        return () => setShowNav(true);
    }, [setShowNav]);

    return (
        <OnboardingLayout>
            <ErrorBoundary
                fallback={(error) => <FallbackErrorModal error={error} />}
            >
                <Suspense fallback={<MainContentPending />}>
                    <Switch>
                        <Route exact path={ONBOARDING_BASE_URL}>
                            <Onboarding />
                        </Route>
                        <Route path={ONBOARDING_PATHS.ONBOARDING_CHECKS}>
                            <OnboardingChecks />
                        </Route>
                        <Route
                            path={ONBOARDING_PATHS.ONBOARDING_PAYMENT_METHOD}
                        >
                            {/* @ts-expect-error Not in TS yet */}
                            <IwStripeProvider stripeKey={getStripePublicKey()}>
                                <AddPaymentMethodForm />
                            </IwStripeProvider>
                        </Route>
                        <Route path={ONBOARDING_PATHS.ONBOARDING_SHAREHOLDERS}>
                            <AddCompanyShareholdersForm />
                        </Route>
                        <Route path={ONBOARDING_PATHS.ONBOARDING_ID_CHECK}>
                            <CompleteIDCheckForm />
                        </Route>
                        <Route path={ONBOARDING_PATHS.ONBOARDING_DOCUMENTS}>
                            <DocumentSigningView />
                        </Route>
                        <Route
                            path={ONBOARDING_PATHS.ONBOARDING_DELIVERY_ADDRESS}
                        >
                            <ConfirmDeliveryAddress />
                        </Route>
                    </Switch>
                </Suspense>
            </ErrorBoundary>
        </OnboardingLayout>
    );
};
